<template>
	<div class="shrink-0 text-sm dark:text-white pl-6"
		 :class="{'w-72 block': !hidden, 'w-8': hidden}"
	>
		<div class="fixed right-0 top-16 z-50"
			 :class="{'w-72 h-screen block bg-gray-100 dark:bg-slate-600 bottom-0': !hidden, 'w-8': hidden}"
		>
			<div v-if="!hidden" @click="toggle"
				 class="font-medium mb-3 py-6 px-5 cursor-pointer items-center flex justify-between space-x-5">
				<div class="leading-none text-lg ">Комментарии</div>
			</div>
			<div v-if="!hidden"
				 class="absolute h-full px-3 inset-0 mt-16 space-y-4 overflow-x-hidden overflow-y-scroll no-scroll">
				<div v-for="row in timeline" :key="row.id">
					<comment
						@click.prevent="processLink(row)"
						v-if="row.item_type === 'comment'"
						:postid="row.post_id"
						:post="row.post"
						:comment="row"
						:highlight="needToHighlight(row)"
						:short="1"
					></comment>
					<a v-if="row.item_type === 'rate'"
					   @click.prevent="processLink(row)"
					   :href="row.url"
					   class="block w-full p-4 rounded text-xs"
					   :class="{
                            'bg-green-100 dark:bg-green-800 text-green-800 dark:text-green-100' : row.rate > 0,
                            'bg-red-100 dark:bg-red-800 text-red-800 dark:text-red-100' : row.rate < 0
                        }"
					   v-html="row.message"
					>
					</a>
					<a v-if="row.item_type === 'reply'"
					   @click.prevent="processLink(row)"
					   :href="row.url"
					   class="block w-full p-4 rounded text-xs bg-blue-100 text-blue-800 dark:bg-blue-800 dark:text-blue-100"
					   v-html="row.message"
					>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Client from "../../js/modules/Client";
import Comment from "../post/Comment";
import Cookies from "js-cookie";
import User from "../../js/modules/User";
import {notify} from "@kyvg/vue3-notification";
import {MainStore} from "../../js/stores/MainStore";
import Urls from "../../js/modules/Urls";
import CommentScroller from "../../js/modules/CommentScroller";

export default {
	components: {Comment},
	data() {
		let user = new User();
		let store = new MainStore();

		return {
			user: user,
			timeline: [],
			store: store,
		};
	},
	methods: {
		toggle() {
			this.store.toggleTimeline();
		},
		load() {
			Client.get('/api/v1.1/timeline')
				.then(response => {
					this.timeline = response.data.data;
				})
				.catch();
		},
		isMobile() {
			return window.innerWidth <= 800;
		},
		processNotification(notification) {
			const isComment = notification.item_type === 'comment';
			const isUpdate = notification.item_action === 'update';

			// Если это коммент, а у родительского поста отключен вывод в таймлайн - не выводим
			if (isComment && notification.disable_timeline) {
				return;
			}

			let user_id = notification?.user?.id ?? notification?.user_id ?? 0;
			let isIgnored = this.user.isCommentsIgnoredForUser(user_id)
				|| this.user.isPostsIgnoredForUser(user_id);

			if (!isIgnored) {
				if (isUpdate) {
					this.updateTimelineItem(notification);
				} else {
					this.timeline = [notification, ...this.timeline].slice(0, 100);
				}
			}
		},
		setTimelineVisibility() {
			this.store.setTimelineVisible(this.isMobile() || Number(Cookies.get('hidden')) || 0);
		},
		processLink(row) {
			let baseUrl = Urls.baseUrl(window.location.href);
			let isLinkToCurrentPagePost = row.url === baseUrl;
			let hash = Urls.hash(row.url);
			let commentElement = hash ? document.querySelector('#' + hash) : null;

			// Если в уведомлении стоит ссылка на текущий пост, но без якоря, то прокручиваем к началу страницы
			if (isLinkToCurrentPagePost) {
				window.scrollTo(0, 0);
			} else {
				if (commentElement) {
					CommentScroller(commentElement);
				} else {
					window.location.href = row.url;
				}
			}
		},
		updateTimelineItem(notification) {
			this.timeline.forEach((item, key) => {
				if (item.item_type === notification.item_type && notification.id === item.id) {
					this.timeline[key] = notification;
				}
			});
		},

		needToHighlight(row) {
			return Number(row.user_id) !== this.user.id() && Number(row?.reply_to_user_id) === this.user.id();
		},
	},
	computed: {
		hidden() {
			return this.store.isTimelineVisible;
		}
	},

	mounted() {
		this.load();

		this.setTimelineVisibility();

		window.onresize = () => this.setTimelineVisibility();

		Echo.private('timeline')
			.listen('.TimelineItem', e => {
				this.processNotification(e.notification);
			});

		Echo.private('timeline.' + this.user.id())
			.listen('.TimelineItem', e => {
				this.processNotification(e.notification);
			});

		Echo.private('users.' + this.user.id())
			.listen('.PostUnpublished', e => {
				notify({
					type: 'error',
					text: 'Ваш пост "' + e.post + '" был распубликован по причине: ' + e.reason,
					duration: 1000000,
				});
			})
	},
}
</script>
